export const getVatPriceProps = (showVAT) => {
  let currencyProps = {
    exclVatProps: {},
    inclVatProps: {}
  };
  if (showVAT) {
    currencyProps = {
      exclVatProps: { showVAT: true, tax: false },
      inclVatProps: { showVAT: true, tax: true }
    }
  }
  return currencyProps;
}